<template>
  <b-card no-body :class="{ 'card-transparent-background my-0 pt-0': type == 'view' || type == 'edit' }">
    <b-card-body :class="{
      'p-2': type == 'register',
      'p-0': type == 'view' || type == 'edit',
    }">
      <div class="container" :class="{
        'mx-0': type == 'view' || type == 'edit',
      }">
<!--        <b-row>-->
<!--          <b-col sm="12">-->
<!--            <b-form-group class="form-group-garden-help"-->
<!--              :label="type != 'view' ? 'Experience Level*' : 'Experience Level'" label-for="experience_level"-->
<!--              :experience_level="experience_level" label-class="form-label-garden-help"-->
<!--              :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"-->
<!--              :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"-->
<!--              :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12" label-cols="12"-->
<!--              content-cols="12">-->
<!--              <p class="error_validation_message_p_gardenhelp" v-if="invalid_experience_level">-->
<!--                Please select experience level-->
<!--              </p>-->
<!--              <v-select v-if="type == 'register' || type == 'edit'" :options="experience_level_options"-->
<!--                v-model="_experience_level" name="experience_level" title="experience_level"-->
<!--                placeholder="Select experience level" :reduce="(item) => item.code" :clearable="false" required>-->
<!--              </v-select>-->
<!--              <span v-if="type == 'view'" class="form-control form-control-garden-help">-->
<!--                {{ _experience_level }}-->
<!--              </span>-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--        </b-row>-->
        <b-row>
<!--          <b-col sm="12" v-if="is_company == null || is_company == 0">-->
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Choose Service*' : 'Services/Skills'"
              label-for="service" :service="service" label-class="form-label-garden-help"
              :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
              :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
              :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12" label-cols="12"
              content-cols="12">
              <p class="error_validation_message_p_gardenhelp" v-if="invalid_service">
                Please select service
              </p>
              <v-select v-if="type == 'register' || type == 'edit'" :options="service_options" v-model="_service"
                name="service" title="service" placeholder="Choose service" label="name" :reduce="(item) => item.id"
                :clearable="false" :multiple="true" :closeOnSelect="true" required>
              </v-select>
              <input type="text" class="d-none" name="service" :value="getSelectedServices(service)">
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ services_str.toString().replaceAll(',', ', ') }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
<!--        <b-row v-if="is_sub_contractor != true">-->
<!--          <b-col sm="12">-->
<!--            <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Rate*' : 'Rate'" label-for="rate"-->
<!--              :rate="rate" label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"-->
<!--              :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"-->
<!--              :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"-->
<!--              :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">-->
<!--              <p class="error_validation_message_p_gardenhelp" v-if="invalid_rate">-->
<!--                Please select rate-->
<!--              </p>-->
<!--              <v-select v-if="type == 'register' || type == 'edit'" :options="rate_options" v-model="_rate" name="rate"-->
<!--                title="rate" placeholder="Select rate" :reduce="(item) => item.code" :clearable="false" required>-->
<!--              </v-select>-->
<!--              <span v-if="type == 'view'" class="form-control form-control-garden-help">-->
<!--                {{ _rate }}-->
<!--              </span>-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--        <b-row v-if="is_sub_contractor != true">-->
<!--          <b-col sm="12">-->
<!--            <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Rate Amount*' : 'Rate Amount'"-->
<!--              label-for="rate_amount" :rate_amount="rate_amount" label-class="form-label-garden-help"-->
<!--              :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"-->
<!--              :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"-->
<!--              :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12" label-cols="12"-->
<!--              content-cols="12">-->
<!--              <p class="error_validation_message_p_gardenhelp" v-if="invalid_rate_amount">-->
<!--                Please enter rate amount-->
<!--              </p>-->
<!--              <b-input-group v-if="type == 'register' || type == 'edit'" :append="currency ? currency : 'EUR'"-->
<!--                class="input-group-garden-help">-->
<!--                <b-form-input id="rate_amount" class="form-control-garden-help" type="number" min="0"-->
<!--                  v-model="_rate_amount" :rate_amount="rate_amount" required></b-form-input>-->
<!--              </b-input-group>-->
<!--              <span v-if="type == 'view'" class="form-control form-control-garden-help">-->
<!--                {{ _rate_amount }} {{ currency }}-->
<!--              </span>-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--        </b-row>-->
        <b-row v-if="is_sub_contractor != true">
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" label="VAT Number" label-for="vat_number"
              :vat_number="vat_number" label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
              :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
              :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
              :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">
              <b-form-input v-if="type == 'register' || type == 'edit'" id="vat_number" class="form-control-garden-help"
                v-model="_vat_number" name="vat_no" placeholder="VAT Number"></b-form-input>
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _vat_number ? _vat_number : '-' }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>


<script>
export default {
  name: "WorkInfo",
  components: {},
  props: [
    "type",
    "is_company",
    "experience_level",
    "invalid_experience_level",
    "service_options",
    "service", "services_str", "services_id",
    "invalid_service",
    "rate",
    "invalid_rate",
    "rate_amount",
    "invalid_rate_amount",
    "is_sub_contractor",
    "vat_number",
    "currency",
    "is_staff"
  ],
  data() {
    return {
      experience_level_options: [
        { label: "0-2 years", code: "0-2 years" },
        { label: "2-5 years", code: "2-5 years" },
        { label: "5+ years", code: "5+ years" },
      ],

      rate_options: [
        { label: "Hourly", code: "hourly" },
        { label: "Daily", code: "daily" },
      ],
    };
  },
  updated() { },
  mounted() { },
  computed: {
    _experience_level: {
      get() {
        return this.experience_level;
      },
      set(value) {
        this.$emit("update:experience_level", value);
      },
    },
    _service: {
      get() {
        return this.service;
      },
      set(value) {
        this.$emit("update:service", value);
      },
    },
    _rate: {
      get() {
        return this.rate;
      },
      set(value) {
        this.$emit("update:rate", value);
      },
    },
    _rate_amount: {
      get() {
        return this.rate_amount;
      },
      set(value) {
        this.$emit("update:rate_amount", value);
      },
    },
    _vat_number: {
      get() {
        return this.vat_number;
      },
      set(value) {
        this.$emit("update:vat_number", value);
      },
    },
  },
  methods: {
    getSelectedServices(service) {
      let selectedServices = []
      service.forEach(element => {
        if (Number.isInteger(element)) {
          selectedServices = [element, ...selectedServices]
        }
        if (typeof element === 'object' && element !== null) {
          selectedServices.push(element.id)
        }
      });
      console.log('selectedServices', selectedServices)
      console.log('selectedServices service', service)
      return JSON.stringify(selectedServices)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/WorkInfo.vue